import { render, staticRenderFns } from "./foor-style-4.vue?vue&type=template&id=365fe78a&scoped=true"
import script from "./foor-style-4.vue?vue&type=script&lang=js"
export * from "./foor-style-4.vue?vue&type=script&lang=js"
import style0 from "./foor-style-4.vue?vue&type=style&index=0&id=365fe78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fe78a",
  null
  
)

export default component.exports